var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-resize__wrap"},_vm._l((_vm.handlers),function(item){return _c('div',{key:item,staticClass:"handler",class:item,on:{"mousedown":function($event){$event.stopPropagation();return _vm.onMouseDown(item, $event)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }